import * as CONST from '../ActionTypes';

const initialState = {
  salesPersonList: [],
  csvSalesPersonList: [],
  salesPerson: {},
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
};

function salesPerson(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 販売員全件取得（CSV用）
    // -----------------
    case CONST.GET_CSV_SALES_PERSON_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          csvSalesPersonList: action.payload,
        },
      );
    case CONST.GET_CSV_SALES_PERSON_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          csvSalesPersonList: [],
        },
      );
    // -----------------
    // 販売員一覧取得
    // -----------------
    case CONST.GET_SALES_PERSON_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          salesPersonList: action.payload,
        },
      );
    case CONST.GET_SALES_PERSON_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          salesPersonList: [],
        },
      );
    // -----------------
    // 販売員詳細取得
    // -----------------
    case CONST.GET_SALES_PERSON_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          salesPerson: action.payload,
        },
      );
    case CONST.GET_SALES_PERSON_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          salesPerson: {},
        },
      );
    // -----------------
    // 販売員削除
    // -----------------
    case CONST.DELETE_SALESPERSON_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.DELETE_SALESPERSON_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_DELETE_SALESPERSON_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default salesPerson;
